import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Tentang Kami", to: "/tentang" },
  { label: "Galeri", to: "/galeri" },
  { label: "Kontak", to: "/kontak" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-zinc-800/80 bg-white/85 backdrop-blur-xl">
        <div className="wrap flex h-[72px] items-center justify-between gap-4">
          <Link to="/" data-testid="nav-logo" className="flex items-center">
            <img src="/images/logo.png" alt="Putra Bengawan Logistik" className="logo-img" />
          </Link>
          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <Link
                key={l.label}
                data-testid={`nav-link-${l.to.slice(1) || "home"}`}
                to={l.to}
                className={`text-sm transition-colors ${
                  location.pathname === l.to ? "text-gold-deep" : "text-zinc-300 hover:text-gold-deep"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="hidden lg:block">
            <Link
              data-testid="nav-cta-hubungi"
              to="/kontak"
              className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-gold-deep hover:-translate-y-0.5"
            >
              Hubungi Kami
            </Link>
          </div>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-navy p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </header>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-40 bg-white/97 backdrop-blur-xl lg:hidden overflow-y-auto"
          >
            <nav className="wrap flex flex-col gap-1 pb-10 pt-24">
              {LINKS.map((l, i) => (
                <motion.div
                  key={l.label}
                  initial={{ opacity: 0, x: -18 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.05 * i }}
                >
                  <Link
                    data-testid={`nav-mobile-${l.to.slice(1) || "home"}`}
                    to={l.to}
                    onClick={() => setOpen(false)}
                    className={`block py-3 font-display text-3xl font-bold uppercase transition-colors hover:text-gold-deep ${
                      location.pathname === l.to ? "text-gold-deep" : "text-navy"
                    }`}
                  >
                    {l.label}
                  </Link>
                </motion.div>
              ))}
              <div className="mt-8">
                <Link
                  data-testid="nav-mobile-cta"
                  to="/kontak"
                  onClick={() => setOpen(false)}
                  className="inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-base font-semibold text-white transition-colors hover:bg-gold-deep"
                >
                  Hubungi Kami
                </Link>
              </div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
